<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  '设备编号/资产编码/资产名称/存放地址 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <b-button
              v-if="allow('E')"
              size="sm"
              variant="outline-success"
              class="ml-2"
              @click="$emit('openImport')"
            >
              <i class="el-icon-edit-outline"></i>
              导入
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_status') || '状态'">
              <dict-select
                multiple
                clearable
                v-model="form.statusList"
                :placeholder="$l('tips_select_status') || '请选择状态...'"
                filterable
                size="small"
                url="/sys/common/dict/system"
                :body="{ dictType: 'deviceStatus' }"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="this.$l('form_label_deviceId') || '设备编号'"
              prop="deviceId"
            >
              <el-input
                :placeholder="
                  $l('tips_input_deviceIdassetCode') || '请输入设备编号...'
                "
                v-model="form.deviceId"
                maxlength="50"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_assetCode') || '资产编码'"
              prop="assetCode"
            >
              <el-input
                :placeholder="
                  $l('tips_input_assetCodeassetCode') || '请输入资产编码...'
                "
                v-model="form.assetCode"
                maxlength="50"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_assetName') || '资产名称'"
              prop="assetName"
            >
              <el-input
                :placeholder="$l('tips_input_assetName') || '请输入资产名称...'"
                v-model="form.assetName"
                maxlength="100"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_deviceType') || '设备类型'"
              prop="deviceType"
            >
              <dict-select
                multiple
                clearable
                v-model="form.deviceTypeList"
                :placeholder="
                  $l('tips_select_deviceType') || '请选择设备类型...'
                "
                filterable
                size="small"
                url="/sys/common/dict/system"
                :body="{ dictType: 'deviceType' }"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_specModel') || '规格型号'"
              prop="specModel"
            >
              <el-input
                :placeholder="$l('tips_input_specModel') || '请输入规格型号...'"
                v-model="form.specModel"
                maxlength="100"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_unit') || '设备单位'"
              prop="unit"
            >
              <dict-select
                multiple
                clearable
                v-model="form.unitList"
                :placeholder="$l('tips_select_unit') || '请选择设备单位...'"
                filterable
                size="small"
                url="/sys/common/dict/system"
                :body="{ dictType: 'deviceUnit' }"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_manufacturer') || '生产厂商'"
              prop="manufacturer"
            >
              <el-input
                :placeholder="
                  $l('tips_input_manufacturer') || '请输入生产厂商...'
                "
                v-model="form.manufacturer"
                maxlength="255"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_purchaseDate') || '购买日期'"
                prop="purchaseDate"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.purchaseDateStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tips_select_purchaseDate') || '请选择购买日期'
                      "
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.purchaseDateEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tips_select_purchaseDate') || '请选择购买日期'
                      "
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_storageLocation') || '存放地点'"
              prop="storageLocation"
            >
              <dict-select
                multiple
                clearable
                v-model="form.storageLocationList"
                :placeholder="
                  $l('tips_select_storageLocation') || '请选择存放地点...'
                "
                filterable
                size="small"
                url="/sys/common/dict/system"
                :body="{ dictType: 'storageLocation' }"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_storageAddress') || '存放地址'"
              prop="storageAddress"
            >
              <el-input
                :placeholder="
                  $l('tips_input_storageAddress') || '请输入存放地址...'
                "
                v-model="form.storageAddress"
                maxlength="500"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_custodian') || '保管人'"
              prop="custodian"
            >
              <el-input
                :placeholder="$l('tips_input_custodian') || '请输入保管人...'"
                v-model="form.custodian"
                maxlength="500"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_createBy_name') || '创建人'">
              <dict-select
                v-model="form.createByList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('tips_select_createBy') || '请选择创建人……'"
                size="small"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_modifyBy_name') || '修改人'">
              <dict-select
                v-model="form.modifyByList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('tips_select_modifyBy') || '请选择修改人……'"
                size="small"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('table_label_modified_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  statusList: ['A', 'B'],
}

export default {
  data() {
    return {
      cancelOrderStatusParams: { dictType: 'cancelOrderStatus' },
      advqueryDialogVisible: false,
      form: { ...initForm },

      chooseOrderDialogVisible: false,
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
